import React, { useState, useRef } from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Alert, Button, Form } from 'react-bootstrap';
import { secondsToTime } from '../../utilities/scoringUtilities';
import scoringService from '../../services/ScoringService';

import { v4 as uuidv4 } from 'uuid';

const TryScore = (props) => {

    const { homeTeam, fixtureRoomId, endTeamId, homeTeamPlayers, awayTeamPlayers, realMarkerX, realMarkerY, videoTime, clipStartTime, onCancelButtonClick, startClipId, setShowMultipleSelectedButton, onTryScoreResult, setEndReason } = props;

    const dropdownSelectPlayerRef = useRef(null);
    const [scoreErrorMessages, setScoreErrorMessages] = useState(null);
    const [errorInputIds, setErrorInputIds] = useState(null);
    const [selectedPlayer, setSelectedPlayer] = useState('');

    const eligiblePlayers = (endTeamId == homeTeam.id ? homeTeamPlayers : awayTeamPlayers)
        ?.filter(y => !y.isRedCard && y.shirtNumber);

    const handleSuccessfulTry = async () => {
        if (!selectedPlayer) {
            setScoreErrorMessages([{ id: uuidv4(), text: "Please select a player" }]);
        } else {
            if (realMarkerX == null || realMarkerY == null) {
                setScoreErrorMessages([{ id: uuidv4(), text: "Please select try coordinates" }]);
            } else {
                try {
                    await scoringService.addTryScorer(fixtureRoomId, endTeamId, startClipId, selectedPlayer, realMarkerX, realMarkerY, videoTime, [{ key: 49, value: 1 }]);
                    await setEndReason(null);
                    await setShowMultipleSelectedButton(true);
                    onTryScoreResult(null);
                } catch (err) {
                    setScoreErrorMessages([{
                        id: uuidv4(),
                        text: err?.data?.error?.error || err?.data?.error || err?.data || "An error occurred"
                    }]);
                }
            }
        }
    }

        const getScoreErrorMessageSpan = () => {
            if (scoreErrorMessages && scoreErrorMessages.length > 0) {

                let result = [];

                for (let i = 0; i < scoreErrorMessages.length; i++) {
                    let current = scoreErrorMessages[i];
                    result.push(
                        <Alert key={current.id} variant="danger" className="text-center my-1" onClose={() => {
                            setScoreErrorMessages(scoreErrorMessages && scoreErrorMessages.length > 0 ? scoreErrorMessages.filter((x) => x.id != current.id) : null);
                            setErrorInputIds(errorInputIds && errorInputIds.length > 0 ? errorInputIds.filter((x) => x != current.id) : null);
                        }} dismissible>
                            <span>{current.text}</span>
                        </Alert>);
                }

                return <div className="mb-1" style={{ maxHeight: '240px', overflowY: 'scroll' }}>{result}</div>;
            }
        }

        const scoreErrorMessageSpan = getScoreErrorMessageSpan();

        return<>

            <div className="col-md-12 text-center">
                <h3>Try Score</h3>
                <Row className="pt-2">
                    <Col>
                        <div className="d-flex">
                            <span className="py-1"><b>Select Try Scorer:</b></span>
                            <Form.Control as="select"
                                size="sm"
                                ref={dropdownSelectPlayerRef}
                                value={selectedPlayer}
                                onChange={(event) => { setSelectedPlayer(event.target.value) }}
                                className="ml-1"
                                style={{ width: '175px' }}
                            >
                                <option key="" value="">Please select try scorer...</option>
                                {eligiblePlayers && eligiblePlayers.map(x => {
                                    return <option key={x.shirtNumber} value={x.shirtNumber}>{x.key}</option>
                                })}
                            </Form.Control>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="d-flex">
                            <span className="py-1"> <b>Location: &nbsp; </b></span>
                            <span className="py-1">x: {Math.round(realMarkerX)}m y: {Math.round(realMarkerY)}m</span>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="d-flex">
                            <span className="py-1"> <b>Try awarded at: &nbsp; </b></span>
                            <span className="py-1">{secondsToTime(videoTime)}</span>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="col-md-12 text-center">
                            <Button variant="danger"
                                onClick={async (e) => {
                                    await onCancelButtonClick(e);
                                }}>Cancel</Button>

                            <Button variant="success"
                                onClick={async () => {
                                    await handleSuccessfulTry(realMarkerX, realMarkerY);
                                }}>Save Try</Button>
                        </div>
                    </Col>
                </Row>
            </div>
            {scoreErrorMessageSpan}
        </>;
    
}

export default TryScore;
